import Vue from 'vue';

export default {
  /**
  * @returns {array} lista de actividades por superorden y superorden padre
  */
  async getActivitiesBySuperOrder() {
    const orders = await this.getAdditionalActivities(Vue.prototype.$session.get('orderId'));
    orders.push(await this.getAdditionalActivities(localStorage.getItem('parentSuperOrderId')));
    return orders[0];
  },
  async getAdditionalActivities(superOrderId) {
    const orderId = superOrderId;
    return Vue.prototype.axios
      .get('getactivitiesbysuperorder', {
        params: {
          superOrderId: orderId,
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => {
        const response = res.data;

        if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getUnbudgetedActivities() {
    return Vue.prototype.axios
      .get('getActivityClientByOrder', {
        params: {
          superOrderId: Vue.prototype.$session.get('orderId'),
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => {
        const responseData = res.data;

        if (!responseData.success) throw new Error(`[${responseData.errorCode}] ${responseData.errorDescription}`);

        return responseData.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  updateTutorial() {
    return Vue.prototype.axios
      .put(
        `tutorial?email=${Vue.prototype.$session.get('email')}&superOrderId=${Vue.prototype.$session.get('orderIdDMS')}&value=1&dealerId=${Vue.prototype.$session.get('dealerId')}`,
      )
      .then((res) => res)
      .catch((error) => {
        throw error;
      });
  },
  acceptQuotation(packages) {
    return Vue.prototype.axios
      .put('acceptquotation', {
        dealerId: Vue.prototype.$session.get('dealerId'),
        orderId: Vue.prototype.$session.get('orderId'),
        Packages: packages,
      })
      .then((res) => res)
      .catch((error) => {
        throw error;
      });
  },
  sendPushAdviser() {
    return Vue.prototype.axios
      .put(
        `sendPushAdviser?superOrderId=${Vue.prototype.$session.get('orderIdDMS')}&email=${Vue.prototype.$session.get('email')}&dealerId=${Vue.prototype.$session.get('dealerId')}`,
      )
      .then((res) => res)
      .catch((error) => {
        throw error;
      });
  },
  saveCustomerRejection(orderActivityId, notInterested, reminder) {
    return Vue.prototype.axios
      .post('saveCustomerRejection', {
        order_activity_id: orderActivityId,
        rejection_id: notInterested,
        date_reminder: '',
        description: '',
        contacted: reminder,
        dealerId: `${Vue.prototype.$session.get('dealerId')}`,
      })
      .then((res) => res)
      .catch((error) => {
        throw error;
      });
  },

  getFrozenQuotation() {
    const superOrderId = Vue.prototype.$session.get('orderId');
    return Vue.prototype.axios
      .get('get-quotations-by-order-frozen', {
        params: {
          superOrderId,
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => res.data.data)
      .catch((error) => {
        throw error;
      });
  },

  freezeQuotation() {
    return Vue.prototype.axios
      .post('quotation-frozen', {
        orderId: Vue.prototype.$session.get('orders')[0].orderId,
        dealerId: Vue.prototype.$session.get('dealerId'),
      })
      .then((res) => res.data.data)
      .catch((error) => {
        throw error;
      });
  },
};
